import { Component, OnInit } from '@angular/core';


declare var $: any;
@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

  irInicioPagina() {
    $('body,html').animate({scrollTop : 0}, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer/footer.component.ts